export default __webpack_public_path__ + "static/media/javascript-05.be2df83b.png";